import cn from 'classnames'
import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC, useCallback, useMemo } from 'react'

import { useGetFormDataField } from 'cng-common/features/form'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import { PARTNER_BASIC_INFO_FORM_KEY, partnerBasicInfoFields } from '../../../../../configs'
import { TRANSLATION_KEYS } from '../../../../../translations'
import { CompactFormRichTextEditor } from '../../../../compactFormRichTextEditor/CompactFormRichTextEditor'

import styles from './OneKeyDirectionEditMode.module.scss'

interface IOneKeyDirectionEditModeProps {
  isRequiredForCompleteness: boolean
  oneKeyDirection: Nullable<string>
}

export const OneKeyDirectionEditMode: FC<IOneKeyDirectionEditModeProps> = ({
  isRequiredForCompleteness = false,
  oneKeyDirection,
}) => {
  const [formValue] = useGetFormDataField<Nullable<string>>(
    PARTNER_BASIC_INFO_FORM_KEY,
    partnerBasicInfoFields.achievement
  )

  const tooltipContent = useCallback(
    () => <Translation text={TRANSLATION_KEYS.valueRequiredForCompleteness} />,
    []
  )

  const showCompletenessWarning = useMemo(() => {
    if (!isRequiredForCompleteness) {
      return false
    }

    return formValue === null || formValue === ''
  }, [isRequiredForCompleteness, formValue])

  return (
    <div className={styles.root}>
      <Tooltip disabled={!showCompletenessWarning} tipContent={tooltipContent}>
        <CompactFormRichTextEditor
          className={cn({
            [styles.warning]: showCompletenessWarning,
          })}
          defaultValue={oneKeyDirection || ''}
          field={partnerBasicInfoFields.achievement}
          formKey={PARTNER_BASIC_INFO_FORM_KEY}
        />
      </Tooltip>
    </div>
  )
}
